import {StringUtils} from "@/string-utils";
import {Message} from "@/message";
import {CalendarUtils} from "@/calendar-utils";
import {UserInfoInputModel} from "@/model/user-info/user-info-input.model";

export class UserInfoChecker {

	/**
	 * 全ての項目をチェックします
	 */
    public static checkAll(model: UserInfoInputModel): boolean {
        let result = this.checkName(model);
        result = this.checkKana(model) && result;
        result = this.checkBirthday(model) && result;
        result = this.checkTel(model) && result;
        result = this.checkPostalCode(model) && result;
        result = this.checkGender(model) && result;
        result = this.checkPrefecture(model) && result;

        return result;
    }

    /**
     * 名前をチェックします。
     * @param model 会員情報
     */
    public static checkName(model: UserInfoInputModel): boolean {
        if(!StringUtils.trim(model.name)) {
            model.errorMessages.nameErrorMsg = Message.NOT_INPUT_NAME;
            return false;
        }
        else {
            model.errorMessages.nameErrorMsg = "";
            return true;
        }
    }

    /**
     * 電話番号をチェックします。
     * @param model 会員情報
     */
    public static checkTel(model: UserInfoInputModel): boolean {
        if(!StringUtils.checkTel(model.tel)) {
            model.errorMessages.telErrorMsg = Message.WRONG_TEL;
            return false;
        }
        else {
            model.errorMessages.telErrorMsg = "";
            return true;
        }
    }

    /**
     * お名前(カタカナ) をチェックします。
     * @param model 会員情報
     */
    public static checkKana(model: UserInfoInputModel): boolean {
        // 必須チェック
        if(!StringUtils.trim(model.kana)) {
            model.errorMessages.kanaErrorMsg = Message.NOT_INPUT_NAME_KANA;
            return false;
        }
        // お名前(カタカナ)に入力がある場合、カタカナ入力かチェック
        else if(!StringUtils.checkKatakana(model.kana)) {
            model.errorMessages.kanaErrorMsg = Message.WRONG_KANA;
            return false;
        }
        // エラーがなければメッセージをクリア
        else {
            model.errorMessages.kanaErrorMsg = "";
            return true;
        }
    }

    /**
     * 生年月日のチェックを行います
     * @param model 会員情報
     */
    public static checkBirthday(model: UserInfoInputModel): boolean {
        return this.checkBirthdayNumber(model)
            && this.checkBirthdayInput(model)
            && this.checkBirthdayDate(model)
            && this.checkBirthdayRange(model);
    }

    /**
     * 生年月日の要素が入力されていることをチェックします。
     * @param model 会員情報
     */
    private static checkBirthdayInput(model: UserInfoInputModel): boolean {
        // 年月日に未入力箇所があればメッセージを設定
        if(!StringUtils.trim(model.birthdayYear)
            || !StringUtils.trim(model.birthdayMonth)
            || !StringUtils.trim(model.birthdayDay)
        ){
            model.errorMessages.birthdayErrorMsg = Message.NOT_INPUT_BIRTHDAY;
            return false;
        }
        // 全て入力されていたらメッセージをクリア
        else {
            model.errorMessages.birthdayErrorMsg = "";
            return true;
        }
    }

    /**
     * 生年月日の要素が数字であることをチェックします。
     * @param model 会員情報
     */
    private static checkBirthdayNumber(model: UserInfoInputModel): boolean {
        // 年月日のいずれかが数字でなければエラー
        if(!StringUtils.checkNumber(model.birthdayYear)
            || !StringUtils.checkNumber(model.birthdayMonth)
            || !StringUtils.checkNumber(model.birthdayDay)
        ) {
            model.errorMessages.birthdayErrorMsg = Message.NOT_NUMBER;
            return false;
        }
        // 全てが数字であればメッセージをクリア
        else {
            model.errorMessages.birthdayErrorMsg = "";
            return true;
        }
    }

    /**
     * 生年月日の整合性をチェックします。
     * @param model 会員情報
     */
    private static checkBirthdayDate(model: UserInfoInputModel): boolean {
        // 日付妥当性チェック
        if(!CalendarUtils.checkDate(model.birthdayYear, model.birthdayMonth, model.birthdayDay)) {
            model.errorMessages.birthdayErrorMsg =  Message.WRONG_BIRTHDAY;
            return false;
        }
        // 日付が妥当であればメッセージをクリア
        else {
             model.errorMessages.birthdayErrorMsg =  "";
            return true;
        }
    }

    /**
     * 生年月日の範囲をチェックします。
     * @param model 会員情報
     */
    private static checkBirthdayRange(model: UserInfoInputModel): boolean {
        // 日付範囲チェック
        if (!CalendarUtils.checkDateRange(model.birthdayYear, model.birthdayMonth, model.birthdayDay)) {
            model.errorMessages.birthdayErrorMsg = Message.WRONG_BIRTHDAY;
            return false;
        }
        // 日付が範囲内であればメッセージをクリア
        else {
            model.errorMessages.birthdayErrorMsg = "";
            return true;
        }
    }

    /**
     * 郵便番号をチェックします。
     * @param model 会員情報
     */
    public static checkPostalCode(model: UserInfoInputModel): boolean {
        // 郵便番号チェック
        if(!StringUtils.checkPostalCode(model.postalCode)) {
            model.errorMessages.postalCodeErrorMsg = Message.WRONG_POSTAL_CODE;
            return false;
        }
        // 郵便番号が妥当ならメッセージをクリア
        else {
            model.errorMessages.postalCodeErrorMsg = "";
            return true;
        }
    }

    /**
     * 性別をチェックします。
     * @param model 会員情報
     */
    public static checkGender(model: UserInfoInputModel): boolean {
        // 性別が未入力ならエラー
        if (!StringUtils.trim(model.gender)) {
            model.errorMessages.genderErrorMsg = Message.NOT_INPUT_GENDER;
            return false;
        }
        // 性別が入力されていたらメッセージをクリア
        else {
            model.errorMessages.genderErrorMsg = "";
            return true;
        }
    }

    /**
     * 都道府県をチェックします。
     * @param model 会員情報
     */
    public static checkPrefecture(model: UserInfoInputModel): boolean {
        // 都道府県が未入力ならエラー
        if (!StringUtils.trim(model.prefecture)) {
            model.errorMessages.prefectureErrorMsg = Message.NOT_INPUT_PREFECTURE;
            return false;
        }
        // 都道府県が入力されていたらメッセージをクリア
        else {
            model.errorMessages.prefectureErrorMsg = "";
            return true;
        }
    }
}